import { render, staticRenderFns } from "./TheUploader.vue?vue&type=template&id=86cae996&"
import script from "./TheUploader.vue?vue&type=script&lang=js&"
export * from "./TheUploader.vue?vue&type=script&lang=js&"
import style0 from "./TheUploader.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports